import type { StudentDTO } from "../../domain/contracts";

function escapeCsvCell(value: string | number | null | undefined): string {
  const s = value == null ? "" : String(value);
  if (
    s.includes(",") ||
    s.includes('"') ||
    s.includes("\n") ||
    s.includes("\r")
  ) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

function downloadCsv(filename: string, rows: string[]) {
  const csv = rows.join("\n");
  const blob = new Blob([`\uFEFF${csv}`], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

const GENDER_LABELS: Record<string, string> = {
  male: "ຊາຍ",
  female: "ຍິງ",
  other: "ອື່ນໆ",
};

const STATUS_LABELS: Record<string, string> = {
  active: "ໃຊ້ງານ",
  deactivated: "ປິດການໃຊ້ງານ",
};

function formatDateCell(value: string | null | undefined): string {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return d.toISOString().slice(0, 10);
}

export function exportStudentsCsv(students: StudentDTO[]) {
  const header = [
    "Member ID",
    "ຊື່ຫຼີ້ນ",
    "ຊື່",
    "ກຸ່ມ",
    "ວັນເດືອນປີເກີດ",
    "ເພດ",
    "ເບີໂທ",
    "ອີເມວ",
    "ສະຖານະ",
    "ໝາຍເຫດ",
    "ວັນສ້າງ",
  ].join(",");

  const body = students.map((s) =>
    [
      escapeCsvCell(s.memberId),
      escapeCsvCell(s.nickname),
      escapeCsvCell(s.name),
      escapeCsvCell(s.groupName),
      escapeCsvCell(s.dateOfBirth),
      escapeCsvCell(s.gender ? (GENDER_LABELS[s.gender] ?? s.gender) : ""),
      escapeCsvCell(s.phoneNumber),
      escapeCsvCell(s.email),
      escapeCsvCell(STATUS_LABELS[s.status] ?? s.status),
      escapeCsvCell(s.notes),
      escapeCsvCell(formatDateCell(s.createdAt)),
    ].join(","),
  );

  const stamp = new Date().toISOString().slice(0, 10);
  downloadCsv(`students-${stamp}.csv`, [header, ...body]);
}
